/**
 * Master-data entity → its list route, and the record deeplink built from it.
 *
 * `?id=<id>&source=nav` is the existing nav-redirect contract, not a new one:
 * the list panels read `id` for the selected row, and `useNavSeedSearch` uses
 * `source=nav` to seed the search box from that record's name and then strip the
 * param. A cross-entity detail link already navigates exactly this way.
 */
export const MASTER_DATA_ENTITIES = [
  "supplier",
  "article",
  "product",
  "customer",
  "substance",
] as const

export type MasterDataEntity = (typeof MASTER_DATA_ENTITIES)[number]

const BASE = "/material-compliance/master-data"

export const MASTER_DATA_ROUTES: Record<MasterDataEntity, string> = {
  supplier: `${BASE}/suppliers`,
  article: `${BASE}/articles`,
  product: `${BASE}/products`,
  customer: `${BASE}/customers`,
  substance: `${BASE}/substances`,
}

export function isMasterDataEntity(value: unknown): value is MasterDataEntity {
  return (
    typeof value === "string" &&
    (MASTER_DATA_ENTITIES as readonly string[]).includes(value)
  )
}

export function masterDataRecordRoute(
  entity: MasterDataEntity,
  recordId: string,
): string {
  const params = new URLSearchParams({ id: recordId, source: "nav" })
  return `${MASTER_DATA_ROUTES[entity]}?${params.toString()}`
}
